import { Autocomplete, Box, Button, Paper, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Subheading from "../../../components/common/Subheading";

/**
 * Form section for companies included in the monthly data-checker schedule.
 *
 * @param {Object} props
 * @param {string[]} props.companyNames
 * @param {string[]} props.selectedCompanies
 * @param {Function} props.onCompaniesChange
 * @param {Function} props.onSave
 * @param {boolean} props.saving
 * @returns {JSX.Element}
 */
function ScheduledCompaniesForm({
  companyNames,
  selectedCompanies,
  onCompaniesChange,
  onSave,
  saving,
}) {
  return (
    <Grid container direction="column" spacing={2} p={3} mx={"10%"} pt={0}>
      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Subheading text="Scheduled Companies" sx={{ mb: 1 }} />
        <Box sx={{ mb: 2, color: "text.secondary", fontSize: 14 }}>
          Runs monthly on the 1st at 09:00 (Europe/London) with no quarter.
        </Box>
        <Autocomplete
          options={companyNames}
          multiple
          renderInput={(params) => (
            <TextField {...params} label="Select Scheduled Companies" />
          )}
          onChange={(_, value) => onCompaniesChange(value)}
          getOptionLabel={(option) => option}
          value={selectedCompanies}
          fullWidth
          size="medium"
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button variant="outlined" color="primary" onClick={onSave} disabled={saving}>
            {saving ? "Saving..." : "Save Schedule"}
          </Button>
        </Box>
      </Paper>
    </Grid>
  );
}

export default ScheduledCompaniesForm;
